import hljs from 'highlight.js';

hljs.highlightAll();
